import React from "react";
import { ScrollRestoration } from "react-router-dom";
/**
 *
 *
 * @export
 * @param {*} { header, footer, children, className = "" }
 * @param {string} className dynamic classnames passed in
 * @return {*}
 */
export default function AppShell({
  header,
  footer,
  children,
  className = "",
  dataLayout = "",
}) {
  return (
    <div
      id="app"
      className={`app-shell ${className}`}
      data-layout={`${className}`}
    >
      {/* Skip link for a11y: https://a11y-blog.dev/en/ */}
      <a
        href="#layout"
        aria-label="Skip to content"
        role="link"
        className="visually-hidden-focusable p-2"
      >
        Skip to main content
      </a>
      {/* <div className={`min-h-screen grid grid-rows-[auto_1fr_auto] ${className}`}> */}
      {header ?? null}
      {/* <main id="app-main" className="min-h-0"> */}
      {children}
      {/* </main> */}
      {footer ?? null}

      {/* Back/forward restore + reset on new pages */}
      <ScrollRestoration getKey={(loc) => loc.pathname + loc.hash} />
    </div>
  );
}
